export enum MonetateKeys {
  TRACK_DATA = 'trackData',
  SET_PAGE_TYPE = 'setPageType',
  ADD_PRODUCTS = 'addProducts',
  ADD_PRODUCT_DETAILS = 'addProductDetails',
  ADD_CATEGORIES = 'addCategories',
  ADD_BREADCRUMBS = 'addBreadcrumbs',
  ADD_CART_ROWS = 'addCartRows',
  ADD_PURCHASE_ROWS = 'addPurchaseRows',
}

export enum PageName {
  CHECKOUT_LOGON = 'CheckoutLogon',
  CONFIRMATION = 'Confirmation',
  CORE_MEDIA = 'CoreMediaContentDisplay',
  DELIVERY = 'Delivery',
  DELIVERY_PAGE = 'DeliveryPage',
  HOME_PAGE = 'HomePage',
  PAYMENT = 'Payment',
  PAYMENT_PAGE = 'PaymentPage',
  PAYMENT_REDESIGN = 'paymentRedesign',
  PDP = 'PDP',
  PLP = 'plp',
  PRODUCT_LISTING = 'ProductListing',
  PRODUCT_PAGE = 'ProductPage',
  REMIX_LANDING = 'RemixLanding',
  REMIX_PRODUCT_DISPLAY = 'RemixProductDisplay',
  SEARCH_DISPLAY = 'SearchDisplay',
  SEARCH_RESULTS = 'SearchResults',
  SET_PAGE_TYPE = 'setPageType',
  SHOP_CART = 'ShopCart',
  SHOPPING_CART = 'shoppingCart',
  SORRY_PAGE = '404',
  THANK_YOU_PAGE = 'ThankYouPage',
}

export enum MappedPageName {
  BILLING = 'billing',
  CART = 'cart',
  CATEGORY = 'category',
  CUSTOM = 'custom',
  CUSTOM_PRODUCT = 'customProduct',
  LANDING = 'landing',
  MAIN = 'main',
  OTHER_PAGE = 'other_page',
  PRODUCT = 'product',
  PURCHASE = 'purchase',
  SEARCH = 'search',
  SHIPPING = 'shipping',
  SORRY_PAGE = '404',
}

export type CartItems = Array<Record<string, unknown>>
